import { Box } from '@chakra-ui/react'
import type { FC } from 'react'
import { SimpleEmberLoadProfileGraph } from './LoadProfileDetailsGraph/LoadProfileDetailsGraph'

export const SimpleEmberLoadProfile: FC<{
  entries: {
    timestamp: string
    value_kw: number
  }[]
  hideXAxis?: boolean
  hideDate?: boolean
}> = ({ entries, hideXAxis, hideDate }) => {
  return (
    <Box bg='white' p={'8px'} borderRadius={'8px'}>
      <SimpleEmberLoadProfileGraph data={entries} hideXAxis={hideXAxis} hideDate={hideDate} />
    </Box>
  )
}
